export const skills = [
    { name: "Java (Java 21)", proficiency: 95 },
    { name: "Spring Boot", proficiency: 95 },
    { name: "Microservices", proficiency: 95 },
    { name: "Spring Batch", proficiency: 90 },
    { name: "Kubernetes", proficiency: 85 },
    { name: "Object Oriented Design", proficiency: 95 },
    { name: "Database Design", proficiency: 95 },
    { name: "PostgreSQL / Oracle", proficiency: 90 },
    { name: "API Development (REST)", proficiency: 95 },
    { name: "System Design", proficiency: 90 },
    { name: "High-Performance Systems", proficiency: 90 },
    { name: "Laravel (PHP)", proficiency: 90 },
    { name: "React.js", proficiency: 85 },
    { name: "TypeScript", proficiency: 75 },
    { name: "DevOps (Bitbucket/SonarQube)", proficiency: 80 },
    { name: "Agile (Jira/Confluence)", proficiency: 95 },
    { name: "Git", proficiency: 95 },
    { name: "Problem Solving", proficiency: 95 },
    { name: "Technical Documentation", proficiency: 90 }
];
